import { render, staticRenderFns } from "./xq.vue?vue&type=template&id=01d1f018&"
import script from "./xq.vue?vue&type=script&lang=js&"
export * from "./xq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports